import {
    Pagination,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHeader,
    WindmillContext,
    TableRow
} from "@windmill/react-ui";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PurchaseLineChart from "components/chart/LineChart/PurchaselineCharts";
import PurchaseBarChartComponent from "components/chart/barChart/PurchaseBarchart";
import ChartCardone from "components/chart/ChartCardone";

import SalesCardItemOne from "components/dashboard/SalesCarditem-one";
import SalesCardItemtwo from "components/dashboard/salesCardItemtwo";
import TableLoading from "components/preloader/TableLoading";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";

import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import sidebar from "routes/sidebar";

import DashboardServices from "services/DashboardServices";
import purchaseamountimg
    from "../../assets/purchasedashboardicons/purchaseamountimg.webp";

import payBillimg
    from "../../assets/purchasedashboardicons/payBillimg.webp";

import unpaidbillvalueimg
    from "../../assets/purchasedashboardicons/unpaidbillvalueimg.webp";

import unApprovedBillvalueimg
    from "../../assets/purchasedashboardicons/unApprovedBillvalueimg.webp";

import "../dashboardComponents/Accountsalesdashboard.css"


import Totalpurchaseimg
    from "../../assets/purchasedashboardicons/Totalpurchase.webp";
import unsubmittedBillImg
    from "../../assets/purchasedashboardicons/unsubmittedBillImg.webp";
import UnpaidBillimg
    from "../../assets/purchasedashboardicons/UnpaidBill.webp";
import UnapprovedBillimg
    from "../../assets/purchasedashboardicons/UnapprovedBillimg.webp";


const GRAPHTYPE = {
    week: 1,
    month: 2,
    year: 3,
};

const AccountsPurchaseDashboard = () => {
    const { globalSetting } = useFilter();
    const { mode } = useContext(WindmillContext);
    const { currentPage, handleChangePage, lang } =
        useContext(SidebarContext);
    const { t } = useTranslation();

    const currency = globalSetting?.default_currency || "₹";

    const [view, setView] = useState("month"); // default tab
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [percentageChange, setPercentageChange] = useState(0);



    const adminInfo = localStorage.getItem("adminInfo")
        ? JSON.parse(localStorage.getItem("adminInfo"))
        : null;
    const employeeId = adminInfo?.id
    const {
        data: purchaseData,
        loading: loadingPurchaseData,
        error,
    } = useAsync(() => DashboardServices.getProfileDashboard(employeeId));
    useEffect(() => {
        // console.log("Loading:", loadingPurchaseData);
        // console.log("Data:", purchaseData);
    }, [loadingPurchaseData, purchaseData]);



    const formatDateDMY = (iso) => {
        if (!iso) return "-";

        const date = new Date(iso);
        if (isNaN(date.getTime())) return "-";

        return date.toLocaleDateString("en-GB", {
            timeZone: "UTC",
        });
    };

    useEffect(() => {
        const fetchSalesGraph = async () => {
            try {
                setLoading(true);

                const type = GRAPHTYPE[view];
                const res = await DashboardServices.getDashboardGraphPurchase(type);

                // console.log("----resposne", res);

                const purchaseStates = res?.data.purchase_stats?.chart_data || [];
                // console.log("dsafghkjlfdgh", purchaseStates)
                // console.log("graph data with type", purchaseStates);

                const percentage = res?.data?.purchase_stats?.percentage_change || 0;

                setPercentageChange(Number(percentage));

                const normalizedData = purchaseStates.map((item) => ({
                    label: item.label,
                    total: Number(item.total) || 0,
                }));

                setChartData(normalizedData);
                setPercentageChange(percentage);
            } catch (error) {
                console.error("Sales graph API error:", error);
                setChartData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchSalesGraph();
    }, [view]);
    return (
        <>
            <PageTitle sidebar={sidebar().sidebar} />
            <h1
                style={{
                    color: "black",
                    fontWeight: 600,
                    fontSize: "20px",
                }}
            >
                Current Month Status
            </h1>

            <div className="grid gap-4 mb-8 md:grid-cols-4">

                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Purchase Amount"
                    Img={purchaseamountimg}
                    price={purchaseData?.data?.purchase?.data?.total_purchase_amount || 0}
                    className="bg-white text-black"
                    loading={loadingPurchaseData}
                // onNavigation='/bill-details-payment'
                // current_month={true}
                // type={4}
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Paid Bill Value"
                    Img={payBillimg}
                    price={purchaseData?.data?.purchase?.data?.total_paidbill || 0}
                    className="bg-white text-black"
                    loading={loadingPurchaseData}
                    onNavigation='/bill-details-payment'
                    current_month={true}
                    type={3}
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Unpaid Bill value"
                    Img={unpaidbillvalueimg}
                    price={purchaseData?.data?.purchase?.data?.total_unpaidbill || 0}
                    className="bg-white text-black"
                    loading={loadingPurchaseData}
                    onNavigation='/bill-details-payment'
                    current_month={true}
                    type={1}
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Unapproved Bill Value"
                    Img={unApprovedBillvalueimg}
                    price={purchaseData?.data?.purchase?.data?.total_unapprovedbill || 0}
                    className="bg-white text-black"
                    loading={loadingPurchaseData}
                    onNavigation='/bill-details-approval'
                    current_month={true}
                />
            </div>



            <div className="grid gap-4 md:grid-cols-4 ">
                <SalesCardItemOne
                    card_bg_color='#D7FFDE'
                    title="Total Purchase"
                    Img={Totalpurchaseimg}
                    quantity={purchaseData?.data?.purchase?.data?.purchase_count || 0}
                // onNavigation='/bill-details-payment'
                // current_month={true}
                // type={4}
                />
                <SalesCardItemOne
                    card_bg_color='#FFF3D7'
                    title="Unsubmitted Bill"
                    Img={unsubmittedBillImg}
                    quantity={purchaseData?.data?.purchase?.data?.unsubmitted_bill_count || 0}

                />
                <SalesCardItemOne
                    card_bg_color='#D7DBFF'
                    title="Unpaid Bill"
                    Img={UnpaidBillimg}
                    quantity={purchaseData?.data?.purchase?.data?.unpaid_bill_count || 0}
                    onNavigation='/bill-details-payment'
                    current_month={true}
                    type={1}
                />
                <SalesCardItemOne
                    card_bg_color='#FED7FF'
                    title="Unapproved Bill"
                    Img={UnapprovedBillimg}
                    quantity={purchaseData?.data?.purchase?.data?.unapproved_bill_count || 0}
                    onNavigation='/bill-details-approval'
                    current_month={true}
                    type={1}
                />
            </div>

            <div className="flex flex-wrap justify-between my-8 w-full">
                <ChartCardone
                    cardsize='60'
                    mode={mode}
                    loading={loadingPurchaseData}
                // title={t("")}
                >
                    <PurchaseLineChart percentageChange={percentageChange}
                        view={view}
                        onViewChange={setView}
                        data={chartData}
                        loading={loading} />
                </ChartCardone>

                <ChartCardone
                    cardsize='38'
                    mode={mode}
                    loading={loadingPurchaseData}
                // title={t("")}
                >
                    <PurchaseBarChartComponent purchasechart={purchaseData} />
                </ChartCardone>
            </div>

            <h1 className=" font-bold mb-3 mt-1" style={{ fontSize: "24px" }}>
                Recent Purchases
            </h1>


            {loadingPurchaseData ? (
                <TableLoading row={5} col={7} />
            ) : purchaseData?.data?.recent_purchase?.length > 0 ? (
                <TableContainer>
                    <Table>
                        <TableHeader className="text-center">
                            <tr className="text-sm">
                                <TableCell >SI.NO</TableCell>
                                <TableCell>Booking ID</TableCell>
                                <TableCell >Client Name</TableCell>
                                <TableCell>Travel Date</TableCell>
                                <TableCell>Bill Amount</TableCell>
                                <TableCell>Bill Added Date</TableCell>
                                <TableCell>Payment Type</TableCell>
                                <TableCell>Status</TableCell>
                            </tr>
                        </TableHeader>

                        <TableBody>
                            {purchaseData?.data?.recent_purchase?.map((row, index) => (


                                <TableRow key={index} className="text-center">
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell >
                                        <div className="pt-2 text-blue-400">
                                            <span className="text-sm">{row.booking_id || '-'}</span>
                                        </div>
                                    </TableCell>
                                    <TableCell>{row.client_name || '-'}</TableCell>

                                    <TableCell className="text-center">
                                        {row.start_date && row.end_date ? (
                                            <>
                                                <div>{formatDateDMY(row.start_date || '-')}</div>
                                                <div className="pt-3">{formatDateDMY(row.end_date || '-')}</div>
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </TableCell>


                                    <TableCell>{row.bill_amount || '-'}</TableCell>

                                    <TableCell>{formatDateDMY(row.bill_added_date || '-')}</TableCell>

                                    <TableCell>{row.payment_type || '-'}</TableCell>

                                    <TableCell>
                                        {row.bill_approval_status === "1" && (
                                            <span className="text-green-600">Approved</span>
                                        )}

                                        {row.bill_approval_status === "0" && (
                                            <span className="text-yellow-600">Unapproved</span>
                                        )}
                                        {row.bill_approval_status === "2" && (
                                            <span className="text-red-600">Rejected</span>
                                        )}
                                        {row.bill_approval_status == null && "-"}
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <NotFound title="No recent sales found" />
            )}
        </>
    );
};

export default AccountsPurchaseDashboard;
